<template>
    <v-footer
      color="#1D2939"
      style="margin-top: auto;"
      class="white--text text-caption hidden-md-and-down"
    >
      <v-row no-gutters justify="center">
        <v-col cols="12" class="d-flex justify-center align-center">
          <v-row no-gutters justify="center" align="center">
            <v-col cols="auto">
              <v-img
                src="@/assets/logofs.svg"
                width="80"
                class="mx-auto mt-1 mr-3"
              ></v-img>
            </v-col>
            <v-col cols="auto">
              <div class="mt-2">
                <span style="font-size: small; margin-bottom: 5px; color: white"
                  >Copyright © Forward System Limited. All rights reserved.</span
                >
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-footer>
</template>
<script>

export default {
  data() {
    return {
    };
  },

  
};
</script>
